import { useMemo } from 'react';
import { ProductPriceType, PriceType, ProductPriceToDisplayProps } from '../../product-card/types';

export const usePricePrioritization = (
  price: ProductPriceType,
  productPriceCategory: ProductPriceToDisplayProps['productPriceCategory'],
): PriceType => {
  return useMemo(() => {
    const { previous_price: previousPrice, main_price: mainPrice } = price;

    const hasSalePrice =
      (productPriceCategory === 'STD' || productPriceCategory === 'BPR') &&
      previousPrice != null &&
      previousPrice > 0 &&
      mainPrice < previousPrice;

    const hasBestPrice = productPriceCategory === 'BPR' && (previousPrice ?? 0) === 0;

    if (hasSalePrice) {
      return 'discount';
    }

    if (hasBestPrice) {
      return 'best';
    }

    return 'default';
  }, [price, productPriceCategory]);
};
